export default {
    setCountries(state, payload) {
        state.countries = payload;
    },
};
